<template>
  <div id="dropzone-template" class="hidden">
    <div class="py-4 px-2 w-full flex items-center justify-center dz-wrapper">
      <div class="dz-preview">
        <div class="dz-image">
          <img data-dz-thumbnail />
        </div>
        <div class="dz-details flex flex-col justify-between">
          <div class="dz-size">
            <span data-dz-size></span>
          </div>
          <div class="dz-filename">
            <span data-dz-name></span>
          </div>
        </div>
        <div class="dz-progress">
          <span class="dz-upload" data-dz-uploadprogress></span>
        </div>
        <div class="dz-error-message">
          <span data-dz-errormessage></span>
        </div>
        <div class="dz-success-mark">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54">
            <path d="m23.5 31.843-5.915-5.915a4 4 0 0 0-5.657 5.657l8.487 8.487c.098.098.2.19.307.277a4.005 4.005 0 0 0 5.624-.038l16.965-16.965a4 4 0 1 0-5.657-5.657L23.5 31.843ZM27 53c14.36 0 26-11.64 26-26S41.36 1 27 1 1 12.64 1 27s11.64 26 26 26Z" stroke-opacity=".199" stroke="#747474" fill-opacity=".817" fill="#FFF" fill-rule="evenodd"/>
          </svg>
        </div>
        <div class="dz-error-mark">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54">
            <path d="m32.657 29 5.654-5.654a4 4 0 1 0-5.657-5.657L27 23.343l-5.654-5.654a4 4 0 1 0-5.657 5.657L21.343 29l-5.654 5.654a4 4 0 1 0 5.657 5.657L27 34.657l5.654 5.654a4 4 0 1 0 5.657-5.657L32.657 29ZM27 53c14.36 0 26-11.64 26-26S41.36 1 27 1 1 12.64 1 27s11.64 26 26 26Z" stroke="#747474" stroke-opacity=".199" fill="#FFF" fill-opacity=".817" fill-rule="evenodd"/>
          </svg>
        </div>
      </div>
      <div class="flex flex-1 flex-wrap items-center justify-evenly dz-options-wrapper">
        <div class="mr-5 mb-3 flex flex-1 flex-col">
          <label for="description">Description</label>
          <input type="text" class="mt-1 form-input file-description" size="25">
        </div>
        <div class="mr-5 mb-3 flex flex-col">
          <label for="category_id">Category</label>
          <select class="mt-1 w-fit form-select flex-grow file-category">
            <option value=""></option>
            <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.name }}</option>
          </select>
        </div>
        <div class="mr-5 mb-3 flex flex-col">
          <label for="category_id">Subcategory</label>
          <select class="mt-1 w-fit form-select flex-grow file-subcategory">
            <option value="">Select Category</option>
          </select>
        </div>
        <div class="mt-8 mr-5 mb-3 flex">
          <button type="button" class="text-red-600 text-base hover:text-red-500 font-semibold dz-remove" data-dz-remove>
            Remove
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import filter from 'lodash/filter';
  import includes from 'lodash/includes';

  export default {
    props: {
      allowedCategories: {
        type: [Object, Array],
        required: false
      }
    },

    data() {
      return {
        allCategories: {}
      }
    },

    mounted() {
      this.initCategories();
    },

    computed: {
      categories() {
        if (! this.allowedCategories) {
          return this.allCategories;
        }

        return filter(this.allCategories, (category) => {
          return includes(this.allowedCategories, category.name);
        });
      }
    },

    methods: {
      initCategories() {
        axios.get('/api/documents/categories').then((response) => {
          this.allCategories = response.data;
        }).catch((error) => {
          console.log(error);
        }).finally(() => {
          this.$emit('dropzone-template-initialized')
        });
      },
    }
    }
</script>